/** Google Ads — cruise pages only (fastfares.info/cruises) */
export const CRUISE_GTAG_ID = 'AW-17726800435';
export const CRUISE_GTAG_CONVERSION = 'AW-17726800435/VyOiCJvl1r0cELOE5oRC';
export const CRUISE_GTAG_PHONE = '1-888-401-4158';
export const CRUISE_GTAG_SCRIPT_ID = 'cruise-gtag-js';
